import { PaginatedApiResponse } from "../types/api";

const DEFAULT_PER_PAGE = 100;

export async function fetchAllPaginated<T>(
  fetchPage: (page: number, perPage: number) => Promise<PaginatedApiResponse<T>>,
  perPage = DEFAULT_PER_PAGE
): Promise<T[]> {
  const firstPage = await fetchPage(1, perPage);
  const items = [...firstPage.data];
  const lastPage = firstPage.meta?.last_page ?? 1;

  for (let page = 2; page <= lastPage; page += 1) {
    const response = await fetchPage(page, perPage);
    items.push(...response.data);
  }

  return items;
}
